import type { IconName } from './vocabulary'
/**
 * Family-locked FQN resolver. Used by both `Icon.vue` (runtime, theme
 * provider-driven) and `CompatibilityReport.vue` (preview tiles need
 * to render in the report's chosen family rather than the ambient
 * theme family). Server-side `compileIconToHtml` has its own copy
 * because the server subpath is intentionally decoupled from the
 * browser bundle.
 *
 * Resolution precedence:
 *   1. Consumer-extended registry entry's divergence (if any)
 *   2. Build-time DIVERGENCE map
 *   3. Identity (the concept name itself)
 * Variant rewriters are applied last so phosphor weight / heroicons
 * style / solar style cascade onto the resolved suffix.
 */
import divergenceData from './divergence.json'
import { extendedRegistry } from './extend'
import { rewriteVariant } from './families'

const DIVERGENCE = divergenceData as Partial<Record<IconName, Partial<Record<string, string>>>>

export interface ResolveContext {
  weight?: string
  style?: string
}

export function resolveFqnForFamily(
  name: string,
  family: string,
  ctx: ResolveContext = {},
): string {
  const ext = extendedRegistry.value[name]
  if (ext) {
    const suffix = ext.divergence?.[family] ?? name
    return rewriteVariant(`${family}:${suffix}`, family, ctx)
  }
  const suffix = DIVERGENCE[name as IconName]?.[family] ?? name
  return rewriteVariant(`${family}:${suffix}`, family, ctx)
}
